module.exports = __webpack_public_path__ + "img/语音交互算法.dd6dc4f6.png";